import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const ConfigsReducer = CreateGenericReducer(constructs["config"]);
